var Level;
(function (Level) {
    Level[Level["DEBUG"] = 500] = "DEBUG";
    Level[Level["INFO"] = 400] = "INFO";
    Level[Level["WARN"] = 300] = "WARN";
    Level[Level["ERROR"] = 200] = "ERROR";
    Level[Level["OFF"] = 0] = "OFF";
})(Level || (Level = {}));
export default Level;
